import React, { ReactNode } from 'react';

type TConditionalSoftRenderProps = {
  items: ReactNode[];
  current: number;
};

export const ConditionalSoftRender = ({
  current,
  items,
}: TConditionalSoftRenderProps) => {
  return (
    <>
      {items.map((node, i) => (
        <div
          key={i}
          style={{
            display: current === i ? 'block' : 'none',
            height: '100%',
          }}
        >
          {node}
        </div>
      ))}
    </>
  );
};
